import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '@/core/design-system/Chart';
import { Pie, PieChart } from 'recharts';
import generatePieChartConfig from '../utils/generate-pie-chart-config';
import { useAnalytics } from '@/modules/analytics/hooks/useAnalytics.hook';

interface IUserAgentPieChartProps {
  label: string;
  chartData: { name: string; count: number }[];
  colorMap: Record<string, string>;
  onLegendClick: (item: any) => void;
}

const UserAgentPieChart = ({ label, chartData, colorMap, onLegendClick }: IUserAgentPieChartProps) => {
  const chartConfig = generatePieChartConfig(chartData, colorMap) satisfies ChartConfig;
  const { dateFilter } = useAnalytics();

  return (
    <div className="w-full text-center">
      <p className="text-sm text-lighter">{label}</p>
      <p className="text-xs text-light mt-2">
        {' '}
        {new Intl.DateTimeFormat('en-US', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
        }).format(new Date(dateFilter.start))}{' '}
        -{' '}
        {new Intl.DateTimeFormat('en-US', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
        }).format(new Date(dateFilter.end))}
      </p>
      <ChartContainer config={chartConfig} className="mx-auto aspect-square h-full max-h-[300px]">
        <PieChart>
          {chartData.length ? <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} /> : null}
          <Pie
            data={
              chartData.length
                ? chartData.map((item) => ({
                    ...item,
                    fill: colorMap[item.name],
                  }))
                : [
                    {
                      name: 'No Data',
                      count: 1,
                      fill: '#3e4046',
                    },
                  ]
            }
            dataKey="count"
            nameKey="name"
            innerRadius={60}
          />
          {chartData.length ? (
            <ChartLegend
              content={<ChartLegendContent nameKey="name" onLegendClick={onLegendClick} />}
              className="text-lighter -translate-y-2 flex-wrap gap-2 *:basis-1/4 *:justify-center"
            />
          ) : null}
        </PieChart>
      </ChartContainer>
    </div>
  );
};

export default UserAgentPieChart;
